import React, { useEffect, useRef, useState } from 'react';
import Avatar from 'react-avatar';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import classnames from 'classnames';

import { logout } from '../../../store/actions/auth';
import { UserActions } from '../../../store/actions/users';

import iconArrowDown from '../../../assets/images/ic_arrow_dropdown_profile.svg';
import iconMenu from '../../../assets/images/menu.svg';
import iconDoc from '../../../assets/images/icon_doc.svg';
import iconLinkOut from '../../../assets/images/icon_link_out.svg';
import iconStatus from '../../../assets/images/icon_status.svg';
import iconLogout from '../../../assets/images/ic_dropdown_profile_logout.svg';
import iconCopy from '../../../assets/images/icon_copy_orange.svg';
import iconCompany from '../../../assets/images/company.svg';

const ProfileMenu = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false);

  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();

  const claimIsRoot = useSelector((state) => state.users.signedUserIsRoot);

  const imgProfile = user?.profilePhoto;

  const handleCloseMenu = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleCloseMenu);
    return () => {
      document.removeEventListener('click', handleCloseMenu);
    };
  });

  const handleLogout = () => {
    dispatch(
      UserActions.selectCompanyOrganization(undefined, undefined, false)
    );

    dispatch(logout());
  };

  const shouldIconCompanyAppear =
    (user?.companies?.length > 1 && !claimIsRoot) || claimIsRoot;

  const changeCompany = () => {
    dispatch(
      UserActions.selectCompanyOrganization(undefined, undefined, false)
    );
    localStorage.setItem('isSelectOrg', true);
  };

  const onClickCopyDashboardToken = () => {
    const textArea = document.createElement('textarea');
    textArea.value = user?.dashboard_token;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('Copy');
    textArea.remove();
    toastr.success('Sucesso', 'Token copiado!');
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div>
        <div
          className="usuario-imagem pointer mr-2"
          onClick={() => setIsOpen(!isOpen)}
          ref={buttonRef}
        >
          {imgProfile ? (
            <img alt="Profile avatar" src={imgProfile} />
          ) : (
            <Avatar
              name={user?.name || ''}
              size="45"
              round
              color={Avatar.getRandomColor('sitebase', [
                'red',
                'green',
                'blue',
                'gray',
              ])}
            />
          )}
        </div>
      </div>
      <div
        className={classnames('dropdown-profile-container flex-column', {
          'd-none': !isOpen,
          'd-flex': isOpen,
        })}
        ref={menuRef}
      >
        <img
          className="dropdown-profile-container-arrow"
          src={iconArrowDown}
          alt="Icon arrow down"
        />
        <div
          className="dropdown-profile-container-username"
          onClick={() => user?._id && history.push(`/user/${user?._id}`)}
        >
          {imgProfile ? (
            <img
              className="dropdown-profile-picture"
              src={imgProfile}
              alt="Profile avatar"
            />
          ) : (
            <Avatar
              name={user?.name || ''}
              size="45"
              round
              color={Avatar.getRandomColor('sitebase', [
                'red',
                'green',
                'blue',
                'gray',
              ])}
            />
          )}
          <span className="dropdown-profile-org-name">Minha conta</span>
        </div>
        <div className="divider-dropdown-profile" />
        <div
          className="dropdown-profile-container-item pointer"
          onClick={() => history.push('/home')}
        >
          <img src={iconMenu} alt="" />
          <span>Menu Principal</span>
        </div>
        <div
          className="dropdown-profile-container-item pointer"
          onClick={onClickCopyDashboardToken}
        >
          <img alt="" src={iconCopy} />
          <span>Copiar Dashboard Token</span>
        </div>
        {shouldIconCompanyAppear && (
          <div
            className="dropdown-profile-container-item pointer"
            onClick={changeCompany}
          >
            <img className="img-item" alt="" src={iconCompany} />
            <span>Trocar Empresa</span>
          </div>
        )}
        <a
          target="_BLANK"
          rel="noopener noreferrer"
          href="https://docs.boteria.com.br/"
          style={{ color: '#515f75' }}
        >
          <div className="dropdown-profile-container-item  pointer">
            <img
              style={{ marginLeft: 2, marginTop: -2 }}
              src={iconDoc}
              alt=""
            />
            <span>Documentação</span>
            <img
              style={{ marginLeft: 5 }}
              src={iconLinkOut}
              alt="Icon external link"
            />
          </div>
        </a>
        <a
          target="_BLANK"
          rel="noopener noreferrer"
          href="http://code7omni.freshstatus.io"
          style={{ color: '#515f75' }}
        >
          <div className="dropdown-profile-container-item pointer">
            <img style={{ marginTop: -2 }} src={iconStatus} alt="Icon status" />
            <span>Status</span>
            <img
              style={{ marginLeft: 5 }}
              src={iconLinkOut}
              alt="Icon external link"
            />
          </div>
        </a>
        <div
          className="dropdown-profile-container-item mb-2 pointer"
          onClick={() => handleLogout()}
        >
          <img
            style={{ marginLeft: 3, marginTop: -2 }}
            src={iconLogout}
            alt="Icon logout"
          />
          <span>Sair</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileMenu;
